module.exports = __webpack_public_path__ + "media/images/payments/sage-dark-b5a47ba9c22161ea886c2b238805da6d.svg";